import type { SearchUsers200UsersItem } from './searchUsers200UsersItem';

export type SearchUsers200 = {
  query?: string;
  totalResults?: number;
  users?: SearchUsers200UsersItem[];
};
